export function floatLabel() {

	let input = document.querySelectorAll('.form-group .form-control');
	
	for (let i = 0; i < input.length; i++) {

		input[i].parentNode.parentNode.classList.add('e-input-focus');
		
		if(!!input[i].value) {
			input[i].parentNode.parentNode.classList.remove('e-input-focus');
		}

		//Focus Event binding for input component
	    input[i].addEventListener('focus', function() {
	       	this.parentNode.parentNode.classList.remove('e-input-focus');
	    });

	    //Blur Event binding for input component
	    input[i].addEventListener('blur', function() {
	    	if(!this.value) {
	        	this.parentNode.parentNode.classList.add('e-input-focus');
	    	}
	    });
	}
}